import React from "react";
import { useMessageGetter } from "react-message-context";
import { inject, observer } from "mobx-react";
import {
  emptyError,
  invalidTextFieldError,
  isBlank,
  useUpdateIncluded,
  isValidText,
} from "../../../utils/commonUtils";
import TextField from "./TextField";

const CustomerName = observer(({ FeedbackStore }) => {
  const key = "name";
  const { feedback, updateError, updateValue, updateIncluded } = FeedbackStore;
  const name = feedback.name;
  const msgs = useMessageGetter("feedback.form.name");

  // Update included property when customer info value changes
  useUpdateIncluded(key, feedback.customerInfo.value, updateIncluded);

  const handleOnChange = (value) => {
    updateError(key, false);
    updateValue(key, value);
  };

  const handleOnBlur = () => {
    if (isBlank(name.value)) {
      updateError(key, emptyError(msgs));
    } else {
      updateError(
        key,
        isValidText(name.value) ? false : invalidTextFieldError(msgs)
      );
    }
  };

  return (
    <TextField
      fieldName={key}
      autocomplete={key}
      value={name.value}
      error={name.error}
      handleOnChange={handleOnChange}
      handleOnBlur={handleOnBlur}
      maxLength={50}
    />
  );
});

export default inject("FeedbackStore")(CustomerName);
